export type AnalyticsIdentityInput = {
  email?: string | null;
  emailVerified?: Date | string | boolean | null;
  idVerified?: boolean | null;
  name?: string | null;
  onboarded?: Date | string | boolean | null;
  organization?: string | null;
  organizationId?: string | null;
  phoneVerified?: boolean | null;
  role?: string | null;
  type?: string | null;
};

export type AnalyticsOrganizationInput = {
  id?: string | null;
  organizationId?: string | null;
  type?: string | null;
};

export function buildAnalyticsIdentityProperties(
  user: AnalyticsIdentityInput
): Record<string, string | boolean | undefined> {
  return {
    email: user.email ?? undefined,
    name: user.name ?? undefined,
    email_verified: Boolean(user.emailVerified),
    id_verified: user.idVerified ?? undefined,
    onboarded: Boolean(user.onboarded),
    organization_id: user.organizationId ?? user.organization ?? undefined,
    phone_verified: user.phoneVerified ?? undefined,
    role: user.role ?? undefined,
    type: user.type ?? undefined,
  };
}

export function buildAnalyticsGroupProperties(
  organization: AnalyticsOrganizationInput
): Record<string, string | undefined> {
  return {
    organization_id:
      organization.organizationId ?? organization.id ?? undefined,
    type: organization.type ?? undefined,
  };
}
